import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60a46f6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }

import { useI18n } from "vue-i18n"
import { ref, onMounted, computed, Ref } from "vue"
import { Applicant, AssignedDoctor, RequestResponse } from "@/types"
import { doctorActions } from "@/stores/doctor-actions"
import { FormatDateFunction } from "@/types/spec"
import router from "@/router"
import { hospitalActions } from "@/stores/hospital-actions"

export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationsTable',
  props: {
    tab: {},
    isHospital: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const applicants = ref<Applicant[]>([])

const tab = ref(props.tab)
const loading = ref(false)
const { t } = useI18n()
const docAction = doctorActions()
const hospitalAction = hospitalActions()

const page = ref(1)
const itemsPerPage = ref(20)

const requestResponse = ref()
const headers = computed(() => {
  const initialHeaders = [
    {
      title: "",
      key: "photo",
      sortable: false,
      align: "center",
    },
    { title: t("table.name"), key: "name", sortable: false, align: "center" },
    { title: t("table.uni"), key: "uni", sortable: false, align: "center" },
    {
      title: t("table.start-date"),
      key: "startDate",
      sortable: true,
      align: "center",
    },

    {
      title: t("table.end-date"),
      key: "endDate",
      sortable: true,
      align: "center",
    },
  ]

  if (props.isHospital) {
    initialHeaders.push({
      title: t("table.assigned-doctor"),
      key: "doctor",
      sortable: false,
      align: "center",
    })
  }

  initialHeaders.push({
    title: t("table.action"),
    key: "action",
    sortable: false,
    align: "center",
  })
  return initialHeaders
})

onMounted(() => {
  loadApplications()
})

const doctorName = (doctor: AssignedDoctor | null) => {
  if (doctor == null) {
    return "-"
  }
  return `${doctor?.title} ${doctor?.firstName} ${doctor?.lastName}`
}

const loadApplications = async () => {
  loading.value = true
  let response: RequestResponse
  if (props.isHospital) {
    response = await hospitalAction.getApplications(
      tab.value,
      page.value,
      itemsPerPage.value
    )
  } else {
    response = await docAction.getApplications(
      tab.value,
      page.value,
      itemsPerPage.value
    )
  }

  if (response.success) {
    applicants.value = response.result as Applicant[]
  }
  requestResponse.value = response
  loading.value = false
}

const applicantsArray = computed((): any => {
  const array: any[] = []

  applicants.value.forEach((applicant) => {
    console.log("app", applicant)

    const singleApplicant = {
      id: applicant._id,
      photo: applicant.profileUrl,
      name: applicant.firstName + " " + applicant.lastName,
      uni: applicant.university,
      startDate: FormatDateFunction(applicant.startDate ?? "1900-01-01"),
      endDate: FormatDateFunction(applicant.endDate ?? "1900-01-01"),
      doctor: doctorName(applicant.assignedDoctor),
    }
    array.push(singleApplicant)
  })

  return array
})

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_request_status, { response: requestResponse.value }, null, 8, ["response"]),
    _createVNode(_component_v_data_table, {
      "items-per-page": itemsPerPage.value,
      "onUpdate:itemsPerPage": _cache[0] || (_cache[0] = ($event: any) => ((itemsPerPage).value = $event)),
      headers: headers.value,
      items: applicantsArray.value,
      loading: loading.value
    }, {
      [`item.photo`]: _withCtx((props) => [
        (props.item.photo)
          ? (_openBlock(), _createBlock(_component_v_img, _mergeProps({ key: 0 }, props, {
              src: props.item.photo,
              alt: "student Image",
              class: "image mb-2",
              referrerpolicy: "no-referrer",
              rel: "noreferrer"
            }), null, 16, ["src"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_v_img, _mergeProps(props, {
                src: require('../../../../../assets/stud-team1.png'),
                alt: "student Image",
                class: "image mb-2",
                referrerpolicy: "no-referrer",
                rel: "noreferrer"
              }), null, 16, ["src"])
            ]))
      ]),
      [`item.action`]: _withCtx((props) => [
        _createVNode(_component_v_btn, _mergeProps(props, {
          color: "rgb(172, 36, 127)",
          onClick: ($event: any) => (
          _unref(router).push({
            path: _ctx.isHospital
              ? `/hospital-dashboard/application/${props.item.id}`
              : `/doctor-dashboard/application/${props.item.id}`,
          })
        )
        }), {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("table.see-applications")), 1)
          ]),
          _: 2
        }, 1040, ["onClick"])
      ]),
      _: 2
    }, 1032, ["items-per-page", "headers", "items", "loading"])
  ], 64))
}
}

})